import { render, staticRenderFns } from "./swipeComponent.vue?vue&type=template&id=55397281&scoped=true"
import script from "./swipeComponent.vue?vue&type=script&lang=js"
export * from "./swipeComponent.vue?vue&type=script&lang=js"
import style0 from "./swipeComponent.vue?vue&type=style&index=0&id=55397281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55397281",
  null
  
)

export default component.exports